const CUSTOMERS = [
    { label: 'Choose', value: 'choose' },
    { label: 'Select Segment', value: 'selectSegment' },
    { label: 'Select Customers', value: 'selectCustomers' },
];
  
const TRIGGERS = [
    { label: 'Choose', value: 'choose' },
    { label: 'Order Placed', value: 1 },
    { label: 'Coupon Redeemed', value: 2 },
    { label: 'Enter Segment', value: 4 },
    { label: 'In Segment', value: 5 },
    { label: 'Exit Segment', value: 6},
  ];
  
const OFFERS = [
    { label: 'Offer 1', value: 'Offer1' },
    { label: 'Offer 2', value: 'Offer2' },
    { label: 'Offer 3', value: 'Offer3' },
    { label: 'Offer 4', value: 'Offer4' },
  ]
  
const SEGMENTS = [
    { label: 'Select Segment', value: 'selectSegment' },
    { label: 'Create Segment', value: 'createSegment' },
    { label: 'Test1', value: 'test1' },
    { label: 'Test2', value: 'test2' },
]
  
const NOTIFICATIONS_TYPES = [
    { label: 'Choose', value: 'choose' },
    { label: 'Email', value: 'email' },
    { label: 'SMS', value: 'sms' },
]

const COUPON_REDEEMED = [
    { label: 'Choose', value: 'choose' },
    { label: 'Coupon 1', value: 'coupon1' },
    { label: 'Coupon 2', value: 'coupon2' },
    { label: 'Coupon 3', value: 'coupon3' },
    { label: 'Coupon 4', value: 'coupon4' },
    { label: 'Coupon 5', value: 'coupon5'},
]

const OPERATORS = [
    { label: 'Choose', value: 'choose' },
    { label: '>=', value: 'greaterThan' },
    { label: '<=', value: 'lessThan' },
]

const OPERATORS_2 = [
    { label: 'Choose', value: 'choose' },
    { label: 'After', value: 'greaterThan' },
    { label: 'Before', value: 'lessThan' },
]


const TIME_ZONES = [
    { label: 'Choose', value: 'choose' },
    { label: 'CST', value: 'CST' },
    { label: 'EST', value: 'EST' },
    { label: 'PST', value: 'PST' },
    { label: 'MST', value: 'MST' },
]

const INTERVALS = [
  { label: 'Day(s)', value: 'day' },
  { label: 'Week(s)', value: 'week' },
  { label: 'Month(s)', value: 'month' },
  { label: 'Year(s)', value: 'year' },
];

const TRANSACTION_CRITERIAS = [
    { label: "Select Criteria", value: "select" },
    { label: "All Customers", value: "allCustomers" },
    { label: "Total Orders", value: "totalOrders", filterOrderValueId: 1 },
    { label: "Total Spends", value: "totalSpends",  filterOrderValueId: 2 },
    { label: "First Order Date", value: "firstOrderDate", filterOrderValueId: 5 },
    { label: "Last Order Date", value: "lastOrderDate", filterOrderValueId: 4 },
    { label: "Average Order Value", value: "averageOrderValue", filterOrderValueId: 6},
    { label: "Coupons Redeemed", value: "couponsRedeemed", filterOrderValueId: 7 },
];


export const LOCAL_STORAGE_INVOICES_KEY = 'invoices';
export const LOCAL_STORAGE_PURCHASE_ORDERS_KEY = 'purchase-orders';

const REPORTING_TYPES = [
    { label: "Total Loyalty Members", value: "totalLoyaltyMembers" },
    { label: "Total Offers redeemed", value: "totalOffersRedeemed" },
    { label: "Total Orders", value: "totalOrders" },
    { label: "Total Order Value", value: "totalOrderValue" },
    { label: "Order/transaction frequency", value: "order/transactionFrequency" },
    { label: "All Members", value: "allMembers" },
];

const INVOICES_STATUS = [
    'STAGED',
    'RECONCILED',
    'PROCESSED',
    'PAID',
];

const STATUS = [
    "COMPLETED",
    "DELIVERED",
    "DRAFT",
    "IN TRANSIT",
    "PENDING",
    "RECONCILED",
];

const PO_STATUS_MAP = {
    INV_RCVD: 'INV_RCVD',
    FULFILLED: 'FULFILLED',
    REJECTED: 'REJECTED',
    RECVD_SHIPMENT: 'RECVD_SHIPMENT',
    RECEIVED: 'RECEIVED',
    RECONCILED: 'RECONCILED',
    INV_FINALIZED: 'INV_FINALIZED',
}

const PO_STATUS = ["DRAFT", "SENT", "RECVD_SHIPMENT", "INV_RCVD", "RECONCILED"]
const PO_STATUS_DISTRIBUTION = ["DRAFT", "RECEIVED", "REJECTED", "FULFILLED", "INV_FINALIZED"]

const DAYS = {
    SUN: 'Sunday',
    MON: 'Monday',
    TUE: 'Tuesday',
    WED: 'Wednesday',
    THU: 'Thursday',
    FRI: 'Friday',
    SAT: 'Saturday'
}


const CONSTANTS = {
    DAYS,
    STATUS,
    OFFERS,
    SEGMENTS,
    TRIGGERS,
    CUSTOMERS,
    OPERATORS,
    COUPON_REDEEMED,
    TIME_ZONES,
    PO_STATUS_MAP,
    INTERVALS,
    PO_STATUS,
    OPERATORS_2,
    REPORTING_TYPES,
    INVOICES_STATUS,
    TRANSACTION_CRITERIAS,
    NOTIFICATIONS_TYPES,
    PO_STATUS_DISTRIBUTION
}



export default CONSTANTS;
